<template>
  <!-- partial -->
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="cardplay solicitud-shell">
        <div class="card-body solicitud-card-body">
              <form-tag @ClienteEditEvent="submitHandler" name="clienteForm" event="clienteEditEvent" id="cliente-form">
                <div class="row dashboard-header g-3 align-items-center mb-4">
                  <div class="col-12 col-lg-4 d-flex align-items-center" style="height: 90%">
                    <button v-if="this.idSolicitud <= 0" type="button" @click="previousPage()"
                      class="btn btn-dark text-center ti-angle-left solicitud-main-btn">
                      Volver
                    </button>
                    <router-link v-else class="btn btn-dark text-center ti-angle-left solicitud-main-btn"
                      to="/mostrar-solicitudes-aceptadas">Volver</router-link>

                  </div>

                  <div class="col-12 col-lg-4 text-center">
                    <h4 v-if="validarGrupo" class="dashboard-title mb-1">
                      {{ noIntegregante }} Integrante
                    </h4>
                    <h4 v-else class="dashboard-title mb-1">
                      Nueva Solicitud de Crédito
                    </h4>
                    <p class="solicitud-subtitle mb-0">Revisa y confirma la solicitud manteniendo el mismo flujo visual.</p>
                  </div>
                  <div class="col-12 col-lg-4 d-flex justify-content-lg-end" style="height: 90%">
                    <input v-if="this.idSolicitud <= 0" type="submit" class="btn btn-dark solicitud-main-btn" value="Siguiente Página" />
                    <div
                      class="btnOptionSolicitud col-12 d-flex flex-wrap justify-content-center gap-3 align-items-center"
                      v-else>


                      <button v-if="this.solicitud.estado === 'Aprobado'" data-bs-toggle="modal"
                        data-bs-target="#otorgarEstado" aria-expanded="true" aria-controls="otorgarEstado"
                        type="button" class="btn btn-primary solicitud-main-btn text-white">
                        Otorgar
                      </button>

                      <div class="d-flex justify-content-center gap-3 align-items-center">
                        <button type="button" v-if="this.solicitud.estado === 'Pendiente'" class="btn btn-warning text-white"
                          disabled>
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button" v-else-if="this.solicitud.estado === 'Aprobado'" class="btn btn-success text-white"
                          disabled>
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button" v-else-if="this.solicitud.estado === 'Rechazado'" class="btn btn-danger text-white"
                          disabled>
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button" v-else-if="this.solicitud.estado === 'Otorgado'" class="btn btn-dark text-white"
                          disabled>
                          Estado {{ this.solicitud.estado }}
                        </button>
                      </div>
                    </div>



                  </div>

                </div>


                <div class="accordion solicitud-accordion" id="accordionPanelsStayOpenExample">
                  <!-- Aqui va datos Solicitante -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne">
                        <div class="col-6">Datos Solicitante</div>
                        <div id="validar-1" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingOne">
                      <div class="accordion-body">
                        <div class="row">
                          <div v-if="validarMiPyme && this.idSolicitud <= 0" class="col-4">
                            <p>Busca por DNI</p>
                            <input v-model="dni" @input="formatInput" placeholder="Ejemplo: 0801-1998-02195"
                              class="form-control" style="height: 20px" type="text" minlength="15" maxlength="15"
                              id="dni" required />
                            <router-link class="nav-link w-100" to="/solicitante/0">Crear Nuevo
                              Beneficiario</router-link>
                          </div>
                          <div v-else class="col-4 d-flex justify-content-center align-item-center"></div>
                          <div v-if="this.cliente" class="col-12">
                            <div class="row mt-3 mb-3">
                              <div class="col-sm-8">
                                <strong>Nombre: </strong> {{ this.cliente.nombres }} {{ this.cliente.apellidos }}
                              </div>
                              <div class="col-sm-4"> <strong>DNI: </strong> {{ this.cliente.dni }}</div>
                            </div>
                            <div class="row mt-3 mb-3">
                              <div class="col-sm-4">
                                <strong>No Teléfono: </strong>{{ this.cliente.celular }}
                              </div>
                              <div class="col-sm-4"><strong>Email: </strong>{{ this.cliente.email }}</div>
                              <div class="col-sm-4">
                                <strong>No Teléfono Negocio: </strong> {{ this.cliente.telefono }}
                              </div>
                            </div>
                          </div>
                        </div>


                        <!-- Aqui va condiciones Credito -->


                      </div>
                    </div>
                  </div>
                  <CondicionesCredito
                    :solicitud="solicitudCondicionesLectura"
                    :solicitud-completa="solicitudCompletaCondicionesLectura"
                    :productos-seleccionables="productoAceptadoSeleccionable"
                    :departamentos="departamentosCondiciones"
                    :pagos-interes="solicitud.pagosInteres || []"
                    :cliente="cliente"
                    :producto-seleccionado-id="productoAceptadoId"
                    :producto-seleccionado-nombre="productoAceptadoNombre"
                    :monto-otorgar="montoOtorgarCondiciones"
                    :arreglo-pago-intereses="!!solicitud.pagosInteres?.length"
                    :monto-a-p-interes="0"
                    :no-pagos-a-p-interes="solicitud.pagosInteres?.length || 0"
                    :validar-pagos-interes="true"
                    :productos-ready="productosReady || !!productoAceptadoNombre"
                    :productos-error="productosError"
                    :producto-config-loading="productoConfigLoading"
                    :producto-config-error="productoConfigError"
                    :modo-thanos="true"
                    :es-credi-trabajo2="creditrabajo2()"
                    :es-crea-futuro="creaFuturo()"
                    :es-micro-credito="microCredito()"
                    :moneda="moneda"
                    :monto-interes="montoInteres"
                    :comision-otorgamiento="comisionOtorgamiento"
                    :total-comision-otorgamiento="totalComisionOtorgamiento"
                    :comision-asistencia-tecnica="comisionAsistenciaTecnica"
                    :total-comision-asistencia-tecnica="totalComisionAsistenciaTecnica"
                    :tasa-seguridad="tasaSeguridad"
                    :total-tasa-seguridad="totalTasaSeguridad"
                    :reservas-seguros="reservasSeguros"
                    :total-reservas-seguros="totalReservasSeguros"
                    :consultas-buro="consultasBuro"
                    :total-consultas-buro="totalConsultasBuro"
                    :cobro-por-a-c-h="cobroPorACH"
                    solo-lectura
                  />
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingSummaryTable">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseSummaryTable" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseSummaryTable">
                        <div class="col-6">
                          Resumen del Crédito
                        </div>
                        <div id="validar-2" class="d-flex justify-content-end me-3" style="width: 100%">

                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseSummaryTable" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingSummaryTable">
                      <div class="accordion-body">
                        <div class="container" id="content">
                          <hr>
                          <table class="datos-table">

                            <tr>
                              <td> <b>Nombre:</b> </td>
                              <td>{{ this.cliente?.nombres }} {{ this.cliente?.apellidos }}</td>
                              <td><b>ID Beneficiario:</b> </td>
                              <td>{{ this.cliente?.dni }}</td>
                            </tr>
                            <tr>
                              <td><b>Producto:</b> </td>
                              <td>{{ this.solicitud?.producto }}</td>
                              <td><b>Numero de préstamo:</b> </td>
                              <td>{{ this.solicitud?.id }}</td>
                            </tr>
                            <tr>
                              <td> <b> IFI: </b> </td>
                              <td>{{ this.cliente?.nombreBanco }}</td>
                              <td><b>Cuenta depósito:</b> </td>
                              <td>{{ this.cliente?.noCuentaBanco }}</td>
                            </tr>
                          </table>
                          <hr />
                          <table class="datos-prestamo-table custom-table">
                            <tr>
                              <td><b>Fecha Apertura:</b></td>
                              <td colspan="1">{{ new Date(this.solicitud?.fechaPago).toLocaleDateString('en-GB') }}</td>
                              <td><b>Monto Aprobado:</b></td>
                              <td>{{ (this.solicitud?.monto).toLocaleString('en-US') }}</td>

                              <td></td>
                            </tr>
                            <tr>
                              <td><b>Tasa Interes:</b></td>
                              <td>{{ this.solicitud?.interes }}%</td>
                              <td><b>Plazo (meses):</b></td>
                              <td>{{ this.solicitud?.plazoPago }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td><b>Forma de pago:</b></td>
                              <td>Mensual</td>
                              <td><b>Moneda:</b></td>
                              <td>Lempiras</td>
                              <td></td>
                            </tr>
                            <tr v-if="this.solicitud.producto === 'Credi Trabajo'">
                              <td><b> Total Interes: </b></td>
                              <td>{{ (this.solicitud?.monto * ((this.solicitud?.interes / 12) /
                                100) * this.solicitud.plazoPago).toLocaleString('en-US', minimumFractionDigits = 2,
                                  maximumFractionDigits = 2) }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <!-- <tr>
                              <td colspan="1"><b>Comision por otorgamiento:</b></td>
                              <td>{{ this.comisionOtorgamiento }}%</td>
                              <td>{{ (this.totalComisionOtorgamiento).toLocaleString('en-US') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="1"><b>Comision por asistencia técnica:</b></td>
                              <td>{{ this.comisionAsistenciaTecnica }}%</td>
                              <td>{{ (this.totalComisionAsistenciaTecnica).toLocaleString('en-US') }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="1"><b>Total Intereses Pagado:</b></td>
                              <td></td>
                              <td>{{ ((this.totalComisionOtorgamiento +
                                this.totalComisionAsistenciaTecnica).toFixed(2)).toLocaleString('en-US') }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="1"><b>Tasa de Seguridad:</b></td>
                              <td>{{ this.tasaSeguridad }}%</td>
                              <td>{{ this.totalTasaSeguridad }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="1"><b>Frecuencia de pagos:</b></td>
                              <td>{{ this.solicitud.frecuenciaPago }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="1"><b>Monto neto a otorgar al cliente:</b></td>
                              <td>{{ (this.montoNeto).toLocaleString('en-US') }}</td>
                              <td></td>
                              <td></td>
                            </tr> -->
                            <tr>
                              <td colspan="1"><b>Tipo de cálculo:</b></td>
                              <td>Cuota Nivelada</td>
                              <td><b>Periodo Base:</b></td>
                              <td>360</td>
                              <td></td>
                            </tr>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </form-tag>
              <div class="modal fade" id="otorgarEstado" tabindex="-1" aria-labelledby="otorgarEstado"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="otorgarEstado">Otorgar</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <OtorgarSolicitud :idSolicitud="this.idSolicitud" :monto="this.solicitud.monto" />

                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
    <!-- partial:../../partials/_footer.html -->
    <footer class="footer">
      <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright ©
          AXCC 2023</span>

      </div>
    </footer>
    <!-- partial -->
  </div>
</template>

<script>
import Security from "../security";
import FormTag from "@/components/forms/Form-Tag.vue";
import { solicitudCompleta } from "../solicitud";
import router from "../../router/index.js";
import Swal from "sweetalert2";
import 'jspdf-autotable';
import OtorgarSolicitud from '../forms/OtorgarSolicitud.vue'
import CondicionesCredito from "./CondicionesCredito.vue";
import { store } from '../store';



export default {
  name: "NuevaSolicitud",
  components: {
    "form-tag": FormTag,
    OtorgarSolicitud: OtorgarSolicitud,
    CondicionesCredito,
  },
  data() {
    return {
      //DATA PARA COMISIONES PARA LA IMPRESION
      comisionOtorgamiento: 2.50,
      totalComisionOtorgamiento: 0.00,
      comisionAsistenciaTecnica: 3.50,
      totalComisionAsistenciaTecnica: 0.0,
      tasaSeguridad: 0.40,
      totalTasaSeguridad: 0.0,
      reservasSeguros: 0.0,
      totalReservasSeguros: 0.0,
      consultasBuro: 0.0,
      totalConsultasBuro: 0.0,
      cobroPorACH: 40.0,
      montoNeto: 0,
      planPagoToPrint: [],
      montoInteres: 0.0,
      montoOtorgar: 0.0,
      idSolicitud: 0,
      validarAcordion: "",
      moneda: 'lps',
      solicitudCompleta,
      productos: [],
      productosReady: false,
      productosError: false,
      productoSeleccionadoId: "",
      productoConfigLoading: false,
      productoConfigError: false,
      productoAceptadoConfiguracion: null,
      fechaNacimiento: "",
      edadsoli: "",
      estadoCivil: "",
      final: false,
      noReferencias: 1,
      dni: "",
      cliente: {},
      gruposSolidariosArray: [],
      solicitud: {
        ID: 0,
        clienteId: 0,
        producto: "",
        fechaPago: "",
        moneda: "lps",
        monto: '',
        frecuenciaPago: "",
        interes: '',
        tipoPlazo: "mensual",
        plazoPago: '',
        garantia: '',
        estado: ''
      },
    };
  },
  beforeMount() {

    this.idSolicitud = this.$route.params.solicitudId
    this.fetchProductos();
    // Obtener GrupoSolidario por edit is id > 0
    if (this.idSolicitud > 0) {
      //editing a solicitante
      fetch(
        process.env.VUE_APP_API_URL +
        "/admin/solicitud/" +
        this.$route.params.solicitudId,
        Security.requestOptions("")
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            // this.Grupo = data.data;
            console.log('Datos Solicitud:', data.data);
            let currentSol = data.data.find((sol) => sol.id == this.$route.params.solicitudId)
            this.solicitud = currentSol
            this.gruposSolidariosArray = data.data
            this.solicitud.fechaPago = currentSol.fechaPago
            this.solicitud.frecuenciaPago = currentSol.frecuenciaPago.toLowerCase()
            this.cliente = currentSol.cliente
            this.sincronizarProductoAceptado(true)
            // solicitudCompleta.integrantes = data.data.clientes
            // this.dni = data.data.dni;
            // this.cliente.estado = data.data.estado;
            // this.comisionAsistenciaTecnica = 3.50
            // this.comisionOtorgamiento = 2.50
            // this.tasaSeguridad = 0.40
            this.montoOtorgar = this.solicitud.montoOtorgar


            this.totalComisionOtorgamiento = this.solicitud.monto * (this.comisionOtorgamiento / 100)
            this.totalComisionAsistenciaTecnica = this.solicitud.monto * (this.comisionAsistenciaTecnica / 100)
            this.totalTasaSeguridad = this.solicitud.monto * (this.tasaSeguridad / 100)
            this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad
          }
        });
    } else if (solicitudCompleta.producto == "") {
      router.push("/solicitud");
      location.reload();
      window.location.href = "/solicitud";
    }
    // if (this.validarMiPyme) {
    //   this.solicitudCompleta.integranteSolicitud+2
    // }

  },

  mounted() {
    Security.requireToken();


    this.totalComisionOtorgamiento = this.solicitud.monto * (this.comisionOtorgamiento / 100)
    this.totalComisionAsistenciaTecnica = this.solicitud.monto * (this.comisionAsistenciaTecnica / 100)
    this.totalTasaSeguridad = this.solicitud.monto * (this.tasaSeguridad / 100)
    this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad
    // if (!this.final) {
    //   Security.secureReload();
    // }
    //Agregar Solicitante
    // if(this.solicitudCompleta.producto != 'MIPYME'){
    //   // this.cliente = solicitudCompleta.integranteSolicitud[solicitudCompleta.integranteSolicitud]

    //   // console.log(this.cliente);
    // }
    // console.log(this.solicitudCompleta.producto);
    // console.log(this.solicitudCompleta.integrantes[this.solicitudCompleta.integranteSolicitud]);
    if (this.idSolicitud <= 0) {
      this.cliente =
        this.solicitudCompleta.integrantes[
        this.solicitudCompleta.integranteSolicitud
        ];
    }


  },
  methods: {
    fetchProductos() {
      const endpoints = ['/productos/all', '/admin/productos/all'];
      this.fetchProductosFromEndpoints(endpoints, 0);
    },
    fetchProductosFromEndpoints(endpoints, index) {
      if (index >= endpoints.length) {
        this.productosReady = true;
        this.productosError = true;
        this.sincronizarProductoAceptado(false);
        return;
      }

      const headers = new Headers();
      headers.append('Authorization', 'Bearer ' + store.token);

      fetch(process.env.VUE_APP_API_URL + endpoints[index], { method: 'GET', headers })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.fetchProductosFromEndpoints(endpoints, index + 1);
            return;
          }

          const productos = response.data?.productos || response.data || [];
          this.productos = this.normalizarProductos(productos);
          this.productosReady = true;
          this.productosError = false;
          this.sincronizarProductoAceptado(true);
        })
        .catch(() => {
          this.fetchProductosFromEndpoints(endpoints, index + 1);
        });
    },
    normalizarProductos(productos) {
      if (!Array.isArray(productos)) {
        return [];
      }

      return productos
        .filter((producto) => producto && producto.nombre)
        .map((producto) => this.normalizarProductoConfiguracion(producto))
        .filter((producto) => producto.nombre !== '');
    },
    normalizarProductoConfiguracion(producto) {
      if (!producto || typeof producto !== 'object') {
        return producto;
      }

      return {
        ...producto,
        nombre: String(producto.nombre || '').trim(),
        periodoPago: Array.isArray(producto.periodoPago) ? producto.periodoPago : [],
        comisiones: Array.isArray(producto.comisiones) || typeof producto.comisiones === 'string' ? producto.comisiones : [],
      };
    },
    getProductoNombre(producto = this.productoAceptadoConfiguracion || this.solicitud.producto || this.solicitudCompleta.producto) {
      if (!producto) {
        return '';
      }

      if (typeof producto === 'object') {
        return String(producto.nombre || '').trim();
      }

      return String(producto).trim();
    },
    sincronizarProductoAceptado(fetchDetalle = false) {
      const productoActual = this.productoAceptadoConfiguracion || this.solicitud.producto || this.solicitudCompleta.producto;
      const productoActualId = this.solicitud.productoId || (productoActual && typeof productoActual === 'object' ? productoActual.id : null);
      const productoActualNombre = this.getProductoNombre(productoActual);

      let productoEncontrado = null;
      if (productoActualId) {
        productoEncontrado = this.productos.find(
          (producto) => String(producto.id) === String(productoActualId)
        );
      }

      if (!productoEncontrado && productoActualNombre) {
        productoEncontrado = this.productos.find(
          (producto) => this.getProductoNombre(producto).toLowerCase() === productoActualNombre.toLowerCase()
        );
      }

      if (!productoEncontrado) {
        this.productoAceptadoConfiguracion = productoActual && typeof productoActual === 'object'
          ? this.normalizarProductoConfiguracion(productoActual)
          : null;
        this.productoSeleccionadoId = productoActualId
          ? String(productoActualId)
          : productoActualNombre ? `actual-${productoActualNombre}` : "";
        return;
      }

      this.productoAceptadoConfiguracion = this.normalizarProductoConfiguracion(productoEncontrado);
      this.productoSeleccionadoId = String(productoEncontrado.id);
      this.solicitud.productoId = productoEncontrado.id || 0;

      if (fetchDetalle && productoEncontrado.id && !String(productoEncontrado.id).startsWith('actual-')) {
        this.fetchProductoSeleccionado(productoEncontrado.id);
      }
    },
    fetchProductoSeleccionado(productoId) {
      const endpoints = [`/productos/${productoId}`, `/admin/productos/${productoId}`];
      this.fetchProductoSeleccionadoFromEndpoints(endpoints, 0, productoId);
    },
    fetchProductoSeleccionadoFromEndpoints(endpoints, index, productoId) {
      if (index === 0) {
        this.productoConfigLoading = true;
        this.productoConfigError = false;
      }

      if (index >= endpoints.length) {
        if (String(this.productoSeleccionadoId) !== String(productoId)) {
          return;
        }
        this.productoConfigLoading = false;
        this.productoConfigError = true;
        return;
      }

      const headers = new Headers();
      headers.append('Authorization', 'Bearer ' + store.token);

      fetch(process.env.VUE_APP_API_URL + endpoints[index], { method: 'GET', headers })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.fetchProductoSeleccionadoFromEndpoints(endpoints, index + 1, productoId);
            return;
          }

          const producto = response.data?.producto || response.data;
          if (!producto) {
            this.fetchProductoSeleccionadoFromEndpoints(endpoints, index + 1, productoId);
            return;
          }

          const productoConfiguracion = this.normalizarProductoConfiguracion(producto);
          if (String(this.productoSeleccionadoId) !== String(productoId)) {
            return;
          }
          this.productoAceptadoConfiguracion = productoConfiguracion;
          this.productoSeleccionadoId = String(productoConfiguracion.id);
          this.solicitud.productoId = productoConfiguracion.id || 0;
          this.productoConfigLoading = false;
          this.productoConfigError = false;
        })
        .catch(() => {
          this.fetchProductoSeleccionadoFromEndpoints(endpoints, index + 1, productoId);
        });
    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(numero)
    },
    creditrabajo2() {
      return this.solicitud.producto === 'Credi Trabajo 2'
    },
    creaFuturo() {
      return this.solicitud.producto === 'CREAFUTURO'
    },
    microCredito() {
      return this.solicitud.producto === 'MICROCREDITO'
    },
    dateFormat(param) {
      // const date = new Date(param)

      // const dia = (param)?.slice(8, 10)
      // const mes = date.toLocaleDateString('es-ES', { month: 'long' })
      // const anio = date.getFullYear()
      // const dateFormated = `${dia}/${mes.slice(0, 3)}/${anio}`
      // return dateFormated
      // Fecha en formato ISO 8601
      // Fecha en formato ISO 8601
      var fechaISO = param;


      // Crear un objeto Date con la fecha proporcionada
      var fecha = new Date(fechaISO);

      // Obtener el día del mes (agregando un cero inicial si es necesario)
      var dia = ('0' + fecha.getUTCDate()).slice(-2);

      // Obtener el mes (agregando un cero inicial si es necesario)
      var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

      // Obtener el año
      var anio = fecha.getUTCFullYear();

      // Formatear la fecha según tus necesidades
      var fechaFormateada = dia + '/' + mes + '/' + anio;

      console.log(fechaFormateada); // Salida: 01/12/2023

      return fechaFormateada;

    },
    onBlur() {
      if (this.esVistaAceptadaLectura) {
        return;
      }

      //Funcion para calcular el monto del credito
      if (this.montoOtorgar > 0 || this.solicitud.monto > 0) {

        // Crea Futuro
        if (this.creaFuturo()) {
          this.solicitud.interes = 12
          this.comisionOtorgamiento = 3.5
          this.comisionAsistenciaTecnica = 4.5
          this.tasaSeguridad = 0.2
          this.reservasSeguros = 1.6
          this.consultasBuro = 0.2

          this.totalComisionOtorgamiento = (this.comisionOtorgamiento / 100) * this.montoOtorgar
          this.totalComisionAsistenciaTecnica = (this.comisionAsistenciaTecnica / 100) * this.montoOtorgar

          this.tasaSeguridad = 0.2
          this.totalTasaSeguridad = (0.2 / 100) * this.montoOtorgar
          this.totalReservasSeguros = (this.reservasSeguros / 100) * this.montoOtorgar
          this.totalConsultasBuro = (this.consultasBuro / 100) * this.montoOtorgar
          this.totalComisionOtorgamiento = parseInt(this.totalComisionOtorgamiento, 10).toFixed(2)
          this.totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10).toFixed(2)

          const montoOtorgar = parseInt(this.montoOtorgar, 10);
          const totalComisionOtorgamiento = parseInt(this.totalComisionOtorgamiento, 10);
          const totalTasaSeguridad = parseInt(this.totalTasaSeguridad, 10);
          const totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10);
          // const cobroPorACH = 40.00;

          if (this.cliente?.nombreBanco === 'Banco de Desarrollo Rural Honduras') {
            this.cobroPorACH = 0.00
          }
          this.solicitud.monto = (montoOtorgar + totalComisionOtorgamiento + totalTasaSeguridad + totalComisionAsistenciaTecnica + this.cobroPorACH + this.totalReservasSeguros + this.totalConsultasBuro).toFixed(2);

        } else if (this.microCredito()) {
          this.comisionOtorgamiento = 6.0
          this.comisionAsistenciaTecnica = 8.0
          this.tasaSeguridad = 0.2
          this.reservasSeguros = 1.6
          this.consultasBuro = 0.2

          this.totalComisionOtorgamiento = (this.comisionOtorgamiento / 100) * this.solicitud.monto
          this.totalComisionAsistenciaTecnica = (this.comisionAsistenciaTecnica / 100) * this.solicitud.monto
          this.totalTasaSeguridad = (0.2 / 100) * this.solicitud.monto
          this.totalReservasSeguros = (this.reservasSeguros / 100) * this.solicitud.monto
          this.totalConsultasBuro = (this.consultasBuro / 100) * this.solicitud.monto
          this.totalComisionOtorgamiento = this.totalComisionOtorgamiento.toFixed(2)
          this.totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica.toFixed(2)

          if (this.cliente?.nombreBanco === 'Banco de Desarrollo Rural Honduras') {
            this.cobroPorACH = 0.00
          }
          this.solicitud.montoOtorgar = (this.solicitud.monto - this.totalComisionOtorgamiento - this.totalTasaSeguridad - this.totalComisionAsistenciaTecnica - this.cobroPorACH - this.totalReservasSeguros - this.totalConsultasBuro).toFixed(2);
          this.montoOtorgar = this.solicitud.montoOtorgar
        } else {

          if (this.solicitud.plazoPago > 0 && this.solicitud.plazoPago < 7) {

            this.totalComisionOtorgamiento = (4.5 / 100) * this.montoOtorgar
            this.totalComisionAsistenciaTecnica = (4.0 / 100) * this.montoOtorgar
            this.totalTasaSeguridad = (0.4 / 100) * this.montoOtorgar
            this.montoInteres = (((this.montoOtorgar * (5 / 100)) * this.solicitud.plazoPago) - (this.totalComisionAsistenciaTecnica + this.totalComisionOtorgamiento))
            // this.solicitud.monto = this.montoOtorgar + this.montoInteres
            this.totalComisionOtorgamiento = parseInt(this.totalComisionOtorgamiento, 10).toFixed(2)
            this.totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10).toFixed(2)
            // Convertir los valores a enteros antes de sumarlos
            const montoOtorgar = parseInt(this.montoOtorgar, 10);
            const montoInteres = parseInt(this.montoInteres, 10);
            const totalComisionOtorgamiento = parseInt(this.totalComisionOtorgamiento, 10);
            const totalTasaSeguridad = parseInt(this.totalTasaSeguridad, 10);
            const totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10);

            if (this.cliente?.nombreBanco === 'Banco de Desarrollo Rural Honduras') {
              this.cobroPorACH = 0.00
            }

            // Asignar la suma a solicitud.monto
            this.solicitud.monto = (montoOtorgar + montoInteres + totalComisionOtorgamiento + totalTasaSeguridad + totalComisionAsistenciaTecnica + this.cobroPorACH).toFixed(2);

            console.log("El campo de interés perdió el foco. Valor actual: " + this.totalComisionOtorgamiento);

          }
        }
      }
      // Lógica adicional que deseas ejecutar cuando se sale del input
    },



  
    //Convertir string a minuscula y sin espacios
    limpiarYMinusc(string) {
      // Eliminar espacios en blanco y convertir a minúsculas
      return string.replace(/\s/g, '').toLowerCase();
    },
    //Convertir numero negativo a 0
    convertirANoNegativo(numero) {
      // Si el número es negativo, convertirlo a cero
      if (numero < 0) {
        return 0;
      } else {
        return numero;
      }
    },
    esCrediTrabajo(producto) {
      // Convertir producto a minúsculas para normalizar
      producto = producto.trim().toLowerCase();

      // Lista de valores normalizados
      const creditrabajo = [
        "creditrabajo",
        "credi trabajo",
        "credi trabajo ",
        "credi trabajo",
        "Credi Trabajo",
        "creditrabajo ",
        "creditrabajo ",
        "credi trabajo",
        "creditrabajo",
      ];

      // Verificar si el producto está en la lista de valores normalizados
      return creditrabajo.includes(producto);
    },
  

    stringToDate(dateString) {
      // Cadena con formato mm/dd/yyyy
      // Diseño que coincide con el formato de la cadena
      let date = new Date(dateString.split("/").reverse().join("-"));
      return date;
    },

    //Enviar Datos
    submitHandler() {
      console.log(this.solicitud)
      //

      this.solicitudCompleta.integranteSolicitud++;

      if (this.solicitudCompleta.solicitudesObject.length >= this.solicitudCompleta.integranteSolicitud) {
        //Se aumenta el no de integrante que se encuentra por segunda vez
        console.log();

        this.solicitud = this.restaurarSolicitud()
        this.cliente = this.solicitudCompleta.integrantes[this.solicitudCompleta.integranteSolicitud];
        console.log('Ya se guardo');

      } else {

        //Se aumenta el no de integrante que se encuentra por segunda vez
        // this.solicitudCompleta.integranteSolicitud++;
        //Agregamos El producto a la solicitud
        this.solicitud.producto = this.productoAceptadoNombre || this.getProductoNombre(this.solicitudCompleta.producto)
        this.solicitud.productoId = parseInt(this.productoAceptadoId, 10) || 0
        //Agregamos el Id del cliente a la solicitud
        this.solicitud.clienteId = this.cliente.id;
        //Convertimos en Enteros y en Float
        this.solicitud.monto = parseFloat(this.solicitud.monto, 10)
        this.solicitud.interes = parseInt(this.solicitud.interes, 10)

        //Agrego solicitud a Payload y la solicitud a solicitudes
        let payload = this.solicitud;
        this.solicitudCompleta.solicitudesObject.push(this.solicitud)
        payload = {
          ...payload,
          idUsuario: Security.getUser()[0].user.id,
        }

        ////////////////////////////
        //Si el integrante por el que va es igual total de integrantes del grupo solidario
        if (
          this.solicitudCompleta.integranteSolicitud ===
          this.solicitudCompleta.integrantes.length
        ) {
          this.solicitudCompleta.integranteSolicitud--;
          Swal.fire({
            title: '¿Estás Seguro de que deseas agregar la solicitud?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, Creala!'
          }).then((result) => {
            if (result.isConfirmed) {

              //Agregar Solicitudes
              this.solicitudCompleta.integranteSolicitud = 0;


              console.log('Se imprimira el payload', payload);
              fetch(`${process.env.VUE_APP_API_URL}/admin/solicitudes/save`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((data) => {
                  if (data.error) {
                    this.$emit('error', data.message)
                    Swal.fire({
                      // position: 'top-end',
                      icon: "error",
                      title: data.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  } else {
                    //Agregar id de solicitud
                    solicitudCompleta.solicitudes.push(data.data.id)
                    //Info Correcta
                    Swal.fire({
                      // position: 'top-end',
                      icon: "success",
                      title: "Se ha Guardado Correctamente la Solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                })
                .catch((error) => {
                  this.$emit('error', error);
                })

              this.solicitudCompleta.integrantes = []
              this.solicitudCompleta.producto = ""
              this.solicitudCompleta.integranteSolicitud = 0
              this.solicitudCompleta.solicitudes = []
              this.solicitudCompleta.solicitudesObject = []



              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Se ha terminado de crear solicitud",
                showConfirmButton: false,
                timer: 1500,
              });
              //Reestablecer Página
              window.onbeforeunload = null; // Desactiva la confirmación de navegación
              this.final = true;
              router.push("/solicitud");
              location.reload();
              window.location.href = "/solicitud";
            }
          })

          /////////////////////////////////////
          //Else Caso contrario que el numero no sea igual al total de intergrantes
        } else {
          //Se guardan los datos del integrate por el que va segun el index que es integranteSolicitud
          this.cliente = this.solicitudCompleta.integrantes[this.solicitudCompleta.integranteSolicitud];
          console.log(payload)
          //Peticion Fetch
          Swal.fire({
            title: '¿Estás Seguro de que deseas modificar la solicitud?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Guardar Cambios!'
          }).then((result) => {
            if (result.isConfirmed) {
              fetch(`${process.env.VUE_APP_API_URL}/admin/solicitudes/save`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((data) => {
                  if (data.error) {
                    //Mensaje Alerta Error
                    Swal.fire({
                      icon: "error",
                      title: data.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });

                  } else {

                    //Agregar id de solicitud
                    solicitudCompleta.solicitudes.push(data.data.id)

                    //Alerta de que guardo correctamente
                    Swal.fire({
                      icon: "success",
                      title: "Se ha Guardado Correctamente la Solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });

                  }
                })
                .catch((error) => {
                  this.$emit('error', error);
                })

              //Se usa funcion que no quita la validación de Seguridad que se perderan los datos  
              this.quitarValidacion()
              this.solicitud = this.restaurarSolicitud()
              //Se resetea el Formulario
              document.getElementById("cliente-form").reset();
              location.reload()
            }
          })
        }
      }
    },


    //Recibir Datos de Otros componentes
    recibirDatosDelHijo(datos) {
      this.cliente = datos; // Manejar los datos recibidos del hijo
      //No funciona
    },


    //Navegar entre Páginas

    //NextPage: Funcion siguiente pagina NO FUNCIONAL POSIBLE BORRAR
    nextPage() {
      console.log('Usted se encuentra en la pagina', this.solicitudCompleta.integranteSolicitud);

      if (this.solicitudCompleta.solicitud[this.solicitudCompleta.integranteSolicitud]) {
        console.log();
      } else {
        this.submitHandler();
      }
      //Se llama la funcion Submit Handler para subir la solicitud



      //Este es cuando es uno que no sea mipyme
      if (
        this.solicitudCompleta.integrantes.length >
        this.solicitudCompleta.integranteSolicitud + 1
      ) {
        console.log('Se llama a la funcion');
        this.solicitudCompleta.integranteSolicitud++;

        //Guardar solicitud de integrante

        //Validar Solicitud
      }
    },

    previousPage() {
      console.log(this.solicitudCompleta.integranteSolicitud);

      if (this.solicitudCompleta.integranteSolicitud > 0) {
        //Ir para atras en las solicitudes

        this.solicitudCompleta.integranteSolicitud--;
        this.cliente =
          this.solicitudCompleta.integrantes[
          this.solicitudCompleta.integranteSolicitud
          ];
        this.solicitud =
          this.solicitudCompleta.solicitudesObject[
          this.solicitudCompleta.integranteSolicitud
          ]

        // console.log('El Id anterior:', this.solicitudCompleta.solicitudes[this.solicitudCompleta.integranteSolicitud].id);
        // router.push(`/solicitud/integrante/${this.solicitudCompleta.solicitudes[this.solicitudCompleta.integranteSolicitud].id}`);

      } else if (this.solicitudCompleta.producto !== "Escalonado") {
        router.push("/solicitud");
      } else {
        router.push("/solicitud/grupo-solidario/0");
      }
    },

    formatInput() {
      // Elimina todos los guiones existentes en el valor actual
      const cleanedValue = this.dni.replace(/-/g, "");

      // Aplica el formato con guiones
      let formattedValue = "";
      for (let i = 0; i < cleanedValue.length; i++) {
        if (i === 4 || i === 8) {
          formattedValue += "-";
        }
        formattedValue += cleanedValue[i];
      }

      // Actualiza el valor del input
      this.dni = formattedValue;
    },
    async quitarValidacion() {
      await new Promise(resolve => setTimeout(resolve, 2000));
      console.log("Se llama a la uncion");
      const inputElement = document.querySelector('.form-control');

      // Elimina la clase CSS que agrega los estilos no deseados
      inputElement.classList.remove('was-validated');
      inputElement.classList.remove('is-invalid');

      // Sobrescribe los estilos en línea para eliminar los estilos no deseados
      inputElement.style.border = 'none';
      inputElement.style.paddingRight = 'initial';
      inputElement.style.backgroundImage = 'none';
      inputElement.style.backgroundRepeat = 'initial';
      inputElement.style.backgroundPosition = 'initial';
      inputElement.style.backgroundSize = 'initial';
    },

    restaurarSolicitud() {
      const solicitud = {
        ID: 0,
        clienteId: 0,
        producto: "",
        fechaPago: "",
        monto: 0,
        frecuenciaPago: "",
        interes: 12,
        tipoPlazo: "",
        plazoPago: 0,
        estado: 'pendiente'
      };

      return solicitud;
    },
    handleOtorgar() {
      const payload = {
        id: parseInt(this.idSolicitud),
        estado: 'Otorgado',
        idUsuario: Security.getUser()[0].user.id,
      }

      console.log(payload)
      Swal.fire({
        title: '¿Estás Seguro que desea otorgar?',
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar!'
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('confirmado')
          fetch(process.env.VUE_APP_API_URL +
            "/admin/solicitud/update-estado", Security.requestOptions(payload))
            .then((response) => response.json())
            .then((data) => {
              if (data.error) {
                this.$emit('error', data.message)
                Swal.fire({
                  // position: 'top-end',
                  icon: "error",
                  title: data.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              } else {
                //Info Correcta
                Swal.fire({
                  icon: "success",
                  title: "Se ha Guardado Correctamente el estado Solicitud",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch((error) => {
              this.$emit('error', error);
            })

          location.reload()
        }
      })
    },
  },
  computed: {
    esVistaAceptadaLectura() {
      return Number(this.idSolicitud) > 0;
    },
    productoAceptadoNombre() {
      return this.getProductoNombre(this.productoAceptadoConfiguracion || this.solicitud.producto || this.solicitudCompleta.producto);
    },
    productoAceptado() {
      const producto = this.productoAceptadoConfiguracion || this.solicitud.producto || this.solicitudCompleta.producto;
      const nombre = this.productoAceptadoNombre;

      if (producto && typeof producto === "object") {
        return {
          ...producto,
          id: producto.id || `actual-${nombre}`,
          nombre,
        };
      }

      return {
        id: nombre ? `actual-${nombre}` : "",
        nombre,
      };
    },
    productoAceptadoId() {
      return this.productoSeleccionadoId || this.productoAceptado.id || "";
    },
    productoAceptadoSeleccionable() {
      return this.productoAceptadoNombre ? [this.productoAceptado] : [];
    },
    departamentosCondiciones() {
      return this.solicitud.sucursal ? [this.solicitud.sucursal] : [];
    },
    montoOtorgarCondiciones() {
      return this.solicitud.montoOtorgar || this.montoOtorgar || 0;
    },
    solicitudCondicionesLectura() {
      return {
        ...this.solicitud,
        pagosInteres: this.solicitud.pagosInteres || [],
      };
    },
    solicitudCompletaCondicionesLectura() {
      return {
        ...this.solicitudCompleta,
        producto: this.productoAceptado,
      };
    },
    noIntegregante() {
      switch (this.solicitudCompleta.integranteSolicitud) {
        case 0:
          return "Primer";
        case 1:
          return "Segundo";
        case 2:
          return "Tercer";
        case 3:
          return "Cuarto";
        case 4:
          return "Quinto";
        default:
          return "Número fuera de rango";
      }
    },
    validarGrupo() {
      if (this.solicitudCompleta.producto === `Escalonado`) {
        return true;
      } else return false;
    },
    validarMiPyme() {
      if (this.solicitudCompleta.producto !== `Escalonado`) {
        return true;
      } else return false;
    },

  },
  watch: {
    // comisionOtorgamiento: function (comisionOtorgamiento) {
    //   this.totalComisionOtorgamiento = this.solicitud.monto * (comisionOtorgamiento / 100)
    //   this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad
    // },
    // comisionAsistenciaTecnica: function (comisionAsistenciaTecnica) {
    //   this.totalComisionAsistenciaTecnica = this.solicitud.monto * (comisionAsistenciaTecnica / 100)
    //   this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad
    // },
    // tasaSeguridad: function (tasaSeguridad) {
    //   this.totalTasaSeguridad = this.solicitud.monto * (tasaSeguridad / 100)
    //   this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad
    // },
    'solicitud.monto': function () {
      if (this.esVistaAceptadaLectura) {
        return;
      }

      if (this.microCredito()) {
        this.onBlur()
      }
    },
    dni(dni) {
      if (Array.from(dni).length == 15) {
        fetch(
          `${process.env.VUE_APP_API_URL}/admin/clientes/dni/${dni}`,
          Security.requestOptions("")
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              console.log(data.message);
              this.$emit("error", data.message);
            } else {
              console.log("Info obtenida", data);
              this.cliente = data.data;
              this.solicitudCompleta.integrantes.push(data.data)
              this.$emit("datos-hijo-al-padre", data.data);
            }
          })
          .catch((error) => {
            this.$emit("error", error);
          });
      } else {
        this.cliente = "";
        this.solicitudCompleta.integrantes.pop()
        // this.mensajeDni = ""
        // dni = document.getElementById('dni');
        // dni.classList.remove('is-invalid')
        // dni.classList.add('was-validated')
      }
    },

    'solicitud.estado': function (estado) {
      if (estado) {
        const formulario = document.getElementById('cliente-form');
        if (!formulario) {
          return;
        }

        const inputs = formulario.querySelectorAll('input')
        const selects = formulario.querySelectorAll('select')
        const inputsComision = formulario.querySelectorAll('.comision')
        const fechaInput = document.getElementById('fecha')
        inputs.forEach((input) => {
          input.disabled = true;
        })
        inputsComision.forEach(input => {
          input.disabled = false;
        })
        selects.forEach(select => {
          select.disabled = true;
        })
        if (fechaInput) {
          fechaInput.disabled = false
        }
        if (estado === 'Otorgado') {
          if (fechaInput) {
            fechaInput.disabled = true
          }
          console.log('Otorgada ', this.idSolicitud)
          fetch(process.env.VUE_APP_API_URL + `/admin/fecha-otorgamiento/${this.idSolicitud}`, Security.requestOptions({}))
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit('error', response.message);
                console.error(response.message)
              } else {
                console.log('Credito:', response)

                // let date = new Date(response.data)



                // ...

                this.fechaPago = response.data.slice(0, 10);
                this.solicitud.fechaPago = response.data.slice(0, 10);

                console.log('response', this.fechaPago)
              }
            })
            .catch(error => {
              this.$emit('error', error)
            })
        }
      }
    },
    'solicitud.plazoPago': function (plazo) {
      console.log(plazo);
      if (this.esVistaAceptadaLectura) {
        return;
      }

      this.onBlur()
      if (this.creditrabajo2()) {
        switch (plazo) {
          case 1:
            this.solicitud.interes = 12
            this.comisionOtorgamiento = 4.27
            this.comisionAsistenciaTecnica = 3.80
            this.tasaSeguridad = 0.40
            break;
          case 2:
            this.solicitud.interes = 8.16
            this.comisionOtorgamiento = 4.08
            this.comisionAsistenciaTecnica = 3.62
            this.tasaSeguridad = 0.40
            break;
          case 3:
            this.solicitud.interes = 22.56
            this.comisionOtorgamiento = 3.9
            this.comisionAsistenciaTecnica = 3.47
            this.tasaSeguridad = 0.40
            break;
          case 4:
            this.solicitud.interes = 28.68
            this.comisionOtorgamiento = 3.74
            this.comisionAsistenciaTecnica = 3.32
            this.tasaSeguridad = 0.40
            break;
          case 5:
            this.solicitud.interes = 31.56
            this.comisionOtorgamiento = 3.59
            this.comisionAsistenciaTecnica = 3.19
            this.tasaSeguridad = 0.40
            break;
          case 6:
            this.solicitud.interes = 33
            this.comisionOtorgamiento = 3.9
            this.comisionAsistenciaTecnica = 3.47
            this.tasaSeguridad = 0.40
            break;
          default:
            this.solicitud.interes = 12
            this.comisionOtorgamiento = 4.27
            this.comisionAsistenciaTecnica = 3.80
            this.tasaSeguridad = 0.40
            break;
        }
      } else if (this.solicitud.producto === "CREAFUTURO") {
        this.solicitud.interes = 12
        this.comisionOtorgamiento = 3.5
        this.comisionAsistenciaTecnica = 4.5
        this.tasaSeguridad = 0.2
        this.reservasSeguros = 1.6
        this.consultasBuro = 0.2
      } else if (this.solicitud.producto === "MICROCREDITO") {
        this.comisionOtorgamiento = 6.0
        this.comisionAsistenciaTecnica = 8.0
        this.tasaSeguridad = 0.2
        this.reservasSeguros = 1.6
        this.consultasBuro = 0.2
      }


    },
  }

};
</script>




<!-- Estilos tabla de amortizacion -->



<!-- Estilos formularios  -->
<style scoped>
.dashboard-shell {
  background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.solicitud-card-body {
  padding: 0;
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  color: #fff;
  padding: 14px 16px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.solicitud-subtitle {
  color: #e5e7eb;
  font-size: 0.95rem;
}

.solicitud-main-btn {
  border-radius: 999px;
  font-weight: 600;
}

.solicitud-accordion {
  border-radius: 18px !important;
}

.solicitud-accordion .accordion-item {
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  overflow: hidden !important;
  margin-bottom: 12px !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06) !important;
}

.solicitud-accordion .accordion-button {
  background: linear-gradient(120deg, #f8fafc 0%, #eef2ff 100%) !important;
  color: #111827 !important;
  font-weight: 700 !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0.9rem 1rem !important;
}

.solicitud-accordion .accordion-button:not(.collapsed) {
  background: linear-gradient(120deg, #111827 0%, #1f2937 100%) !important;
  color: #f9fafb !important;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: royalblue;
}

.custom-table {}


.header,
thead {
  border-bottom: 1px solid #F0F0F0;
  background-color: #F7F7F7;
  padding: 20px 40px;
}

.header h2 {
  margin: 0;
}

#frmPrestamo {
  padding: 30px 40px;
}

#frmPrestamo .control,
#amortizaciones .control,
.radios {
  margin-bottom: 10px;
  padding-bottom: 20px;
  position: relative;
}

#frmPrestamo .control label {
  margin-bottom: 5px;
}

#frmPrestamo .control input,
#frmPrestamo .control select {
  border: 2px solid #F0F0F0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  padding: 10px;
  width: 100%;
}

#frmPrestamo .control input:focus {
  outline: 0;
  border-color: royalblue;
}

#frmPrestamo button {
  background: rgba(65, 105, 225, 90%);
  border: 2px solid royalblue;
  border-radius: 4px;
  color: #FFF;
  display: block;
  font-family: inherit;
  font-size: medium;
  padding: 10px;
  margin-top: 20px;
  width: 100%;
}

.radios {
  padding: 10px 20px;
}

.radioContenedor {
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
  padding-left: 30px;
  margin: 10px;
}

.radioContenedor input {
  display: none;
}

.radioContenedor .circle {
  left: 0;
  top: 0;
  width: 25px;
  height: 25px;
  border-radius: 50px;
  position: absolute;
  display: inline-block;
  background-color: rgba(65, 105, 225, 90%);
  border-bottom: 2px solid royalblue;
}

.radioContenedor:hover .circle {
  background-color: royalblue;
}

.radioContenedor input:checked+.circle {
  background-color: royalblue;
}

.radioContenedor input:checked+.circle:after {
  content: '';
  height: 10px;
  width: 10px;
  background-color: white;
  position: absolute;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
